<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Mapping Advance Group vs User 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="5">
          <b-form-group label-cols=3 label="Filter By User Name">
              <b-input-group >
                  <b-form-input readonly v-model="filter.username" placeholder="Select User !" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="showLkuUser('filter.username')">
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="5">
              <b-row>
                <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-row>
        </b-col>

      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
        <template v-slot:cell(empty)="scope">
              <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
            <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">Mapping Advance Group vs User - Add/Edit Form 
            <div class="card-header-actions">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
              <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
          </div>
          <b-form-group label-cols=3  label="User Name">
              <b-input-group >
                  <b-form-input readonly v-model="frmdata.username" :state="!$v.frmdata.username.$error"></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="showLkuUser('frmdata.username')" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
          </b-form-group>
          <b-form-group label-cols=3  label="Advance Group">
              <b-form-select v-model="frmdata.advKlpId" :plain="true" :options="advGroups" :state="!$v.frmdata.advKlpId.$error"></b-form-select>
          </b-form-group>
        </b-card>
        </b-col>
    </b-row>
    <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of Users" :centered="true">
        <lku-user @click="onSelectUser"></lku-user>
    </b-modal>        
  </div>
</template>


<script>
import lkuUser from "../lookup/lkuUser";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuUser},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        username: { required },
        advKlpId: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      lkuUserShow:false,
      lkuUserCaller:'filter.username',
      filter:{username:''},
      frmdata:{advKlpId: '', username: '' },
      tblData: {
        tablename:'advgroupuser',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      advGroups:[]
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "username",
            label: "User Name",
            sortable: true
          },
          {
            key: "advAccName",
            label: "Advance Group",
            sortable: true
          },
          {
            key: "advAcc",
            label: "Advance Account#",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    username() {
      return this.filter.username;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  watch: {  
    username: function (newval) {
      if (newval) {
          this.tblData.customQuery=`username=${newval}`;
      } else {
          this.tblData.customQuery='';
      }
    }
  },
  created: async function(){
      const arrAdv = await crud.list({tablename:'advgroup', page:1}); 
      this.advGroups = arrAdv.reduce((newArr,item) =>{
            newArr.push({value:item.advKlpId, text:item.advAccName || item.nama, advKlpId:item.advKlpId});
            return newArr;
        },[]);
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.filter.username= '';
        this.refresh();
    },

    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.frmdata.username=this.filter.username
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.tablekey) {
                await crud.update(
                     {tablename:'advgroupuser', 
                     key:this.frmdata.tablekey, 
                     data:{username:this.frmdata.username,
                          advKlpId:this.frmdata.advKlpId
                          }
                      });
              } else {
                await crud.insert(
                  { tablename:'advgroupuser',                      
                     data:{username:this.frmdata.username,
                          advKlpId:this.frmdata.advKlpId
                          }
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'advgroupuser', key:this.model.tablekey});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuUser(callerObj)
    {
      this.lkuUserShow=true;
      this.lkuUserCaller=callerObj;
    },
    // onSelectLkuUser(_selected) {
    //     this[this.lkuUserCaller] = _selected.username;;
    //     // this.filter.full_name = _selected.full_name;
    //     this.lkuUserShow=false;
    // },
    onSelectUser(_selected) {
      const arrCaller=this.lkuUserCaller.split('.');
        this[arrCaller[0]][arrCaller[1]] = _selected.username;;
        // this.filter.full_name = _selected.full_name;
        this.lkuUserShow=false;
    },

    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
